import axios from "axios";
import { cmsHeaders } from "../exports/exports";
import { IMessageData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";

export const fetchHeaderFooter = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/terms-and-conditions-header-footer`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchTermsConditions = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/terms-and-conditions-terms-and-conditions?sort=sort_order:asc`,
      {
        headers: cmsHeaders,
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const submitMessage = async (message: IMessageData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/terms-and-conditions-message`,
      message,
      { headers: cmsHeaders },
    );
    return response;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
